function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#3a559f",
  d: "M32 11h5a1 1 0 001-1V3.263a.997.997 0 00-.925-.997C35.484 2.153 32.376 2 30.141 2 24 2 20 5.68 20 12.368V19h-7a1 1 0 00-1 1v7a1 1 0 001 1h7v19a1 1 0 001 1h7a1 1 0 001-1V28h7.222a1 1 0 00.994-.89l.778-7A1 1 0 0037 19h-8v-5a3 3 0 013-3z"
});

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50"
  }, props), _ref);
}

export default SvgFacebook;